function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercedesBenz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M57.9 47.74l.08-.17v-.07A19.3 19.3 0 0 0 59.5 40a19.5 19.5 0 1 0-37.6 7.22c0 .12.08.24.13.36s.19.4.28.6c.18.37.34.75.54 1.11.08.15.18.3.27.46l.13.2a19.46 19.46 0 0 0 33.5 0c.06-.09.1-.18.16-.28l.37-.66c.23-.41.43-.83.62-1.27zM57.5 40a17.32 17.32 0 0 1-2.1 8.29h-.07l-12.42-9.73a.4.4 0 0 1-.17-.3c-.19-1.38-.39-2.75-.58-4.12s-.35-2.56-.53-3.84-.36-2.53-.53-3.8c-.15-1-.29-2.05-.43-3.08 0-.27-.08-.6-.12-.87A17.51 17.51 0 0 1 57.5 40zm-18-17.47c-.08.54-.15 1.13-.23 1.67-.1.79-.21 1.57-.32 2.35L38.6 29l-.33 2.37c-.11.77-.21 1.54-.32 2.32l-.36 2.62c-.1.68-.19 1.35-.28 2a.38.38 0 0 1-.15.22l-2.31 1.8-10.13 7.93-.1.08a17.47 17.47 0 0 1 14.86-25.8zm.52 35A17.49 17.49 0 0 1 25.63 50c-.09-.13-.18-.26-.26-.39s-.11-.17-.16-.25l.12-.06 4.38-1.79 10.09-4.18a.41.41 0 0 1 .36 0l14.58 5.91h.08l-.1.17-.35.52A17.49 17.49 0 0 1 40 57.51z",
    "data-name": "GL_027x80_mercedes",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercedesBenz);
export default __webpack_public_path__ + "static/media/Mercedes-Benz.1575c3681e547e0277bbc9473b5abc36.svg";
export { ForwardRef as ReactComponent };